<template>
  <div :class="`text-${params.color}`">
    <i :class="params.icon"></i>
    <span class="m-0 ml-2 font-weight-bold">{{ params.text }}</span>
  </div>
</template>

<script>
  export default {
    
  }
</script>

<style lang="scss" scoped>

</style>